import { InfoCard, Progress, WarningPanel } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { IgnoresTable, useSnykIgnores } from './IgnoresTable';

/** Excepciones del .snyk de este componente (ficha, pestaña Snyk). */
export const SnykIgnoresCard = () => {
  const { entity } = useEntity();
  const slug = entity.metadata.annotations?.['github.com/project-slug'];
  const { data, error } = useSnykIgnores(slug ?? '-');
  if (!slug) return null;
  return (
    <InfoCard title="Excepciones (.snyk)" subheader="Vulnerabilidades ignoradas en el .snyk del repo; en rojo, vencidas o a menos de 15 días">
      {error && <WarningPanel title="No se pudieron cargar las excepciones" message={error} />}
      {!data && !error && <Progress />}
      {data && <IgnoresTable rows={data.rows} />}
    </InfoCard>
  );
};
